import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/**
 * This adds a custom overlay on the background of the page.
 */
const Overlay = ({
  image
}) => {
  return jsxs(Fragment, {
    children: [image && jsx("div", {
      "data-testid": "overlay-image",
      className: "background-overlay-image",
      style: {
        width: '100vw',
        height: '600px',
        position: 'absolute',
        zIndex: -1,
        top: 0,
        mixBlendMode: 'multiply',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 30%, rgba(255,255,255,1)), url('${image}')`
      }
    }), jsx("div", {
      "data-testid": "overlay-color",
      style: {
        width: '100vw',
        height: '600px',
        position: 'absolute',
        zIndex: -2,
        top: 0,
        background: `linear-gradient(#12121260, #00000000)`
      }
    })]
  });
};

export { Overlay };
